var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLaunchpack)?_c('user-reg-lp'):_c('user-reg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }